import type { Lang } from "@/i18n/useLang";

export interface SellPackagesCopy {
  seoTitle: string;
  seoDesc: string;
  heading: string;
  b1: string; b2: string; b3: string;
  standardTitle: string; standardSub: string; standardPrice: string;
  standardF1: string; standardF2: string; standardF3: string;
  chooseStandard: string;
  promotedTitle: string; promotedSub: string; promotedPrice: string;
  promotedF1: string; promotedF2: string; promotedF3: string;
  choosePromoted: string;
  activeTitle: string; activeSub: string; activePrice: string;
  activeF1: string; activeF2: string; activeF3: string;
  chooseActive: string;
  recommended: string;
  bestValue: string;
  aiIncluded: string;
  free: string;
  perMonth: string;
  footer: string;
  aiCardTitle: string;
  aiCardBody: string;
}

export const SELL_PACKAGES_COPY: Record<Lang, SellPackagesCopy> = {
  ro: {
    seoTitle: "Vinde mașina ta rapid, fără comisioane | RO Auto Market",
    seoDesc: "Publică-ți anunțul auto în câteva minute. 3 pachete: Standard 9,99 €, Promovat 14,99 € sau Activ până la vânzare 19,99 €/lună.",
    heading: "Vinde mașina ta rapid, fără comisioane",
    b1: "Anunț activ 30 de zile sau până la vânzare",
    b2: "Contact direct cu cumpărătorii",
    b3: "Plată securizată prin Stripe",
    standardTitle: "Standard",
    standardSub: "30 zile · prioritate ușoară în listă",
    standardPrice: "9,99 €",
    standardF1: "Anunț publicat 30 zile",
    standardF2: "Până la 20 de fotografii",
    standardF3: "Prioritate ușoară în rezultate",
    chooseStandard: "Alege Standard",
    promotedTitle: "Promovat",
    promotedSub: "30 zile · vizibilitate maximă",
    promotedPrice: "14,99 €",
    promotedF1: "Tot ce e în Standard",
    promotedF2: "Până la 30 fotografii",
    promotedF3: "Afișare prioritară și insignă Promovat",
    choosePromoted: "Alege Promovat",
    activeTitle: "Activ până la vânzare",
    activeSub: "reînnoire automată lunară · anulează oricând",
    activePrice: "19,99 €",
    activeF1: "Anunț activ cât timp mașina e de vânzare",
    activeF2: "Vizibilitate maximă permanentă",
    activeF3: "Se anulează automat când marchezi „Vândut\"",
    chooseActive: "Alege Activ",
    aiIncluded: "Creare anunț din video cu AI",
    recommended: "Cel mai popular",
    bestValue: "",
    free: "Gratuit",
    perMonth: "/lună",
    footer: "Plata se face după completarea anunțului, prin card, Google Pay sau Apple Pay.",
    aiCardTitle: "Nou: creează anunțul din video, cu AI",
    aiCardBody: "1. Alege pachetul Standard, Promovat sau Activ până la vânzare.\n2. Încarcă un videoclip de 60–90 de secunde cu mașina.\n3. AI extrage automat fotografiile și datele.\n4. Verifici și completezi câmpurile lipsă într-un formular precompletat.\n5. Plătești și trimiți anunțul spre aprobare.\n\nAI nu publică singur. Tu confirmi totul.",
  },
  en: {
    seoTitle: "Sell your car fast, zero commission | RO Auto Market",
    seoDesc: "List your car in minutes. 3 tiers: Standard £9.99, Promoted £14.99 or Active-until-sold £19.99/mo.",
    heading: "Sell your car fast, zero commission",
    b1: "30-day listings, or active until sold",
    b2: "Visible to active buyers",
    b3: "Secure Stripe payments",
    standardTitle: "Standard",
    standardSub: "30 days · standard visibility",
    standardPrice: "£9.99",
    standardF1: "Listing live for 30 days",
    standardF2: "Up to 20 photos",
    standardF3: "Light priority in results",
    chooseStandard: "Choose Standard",
    promotedTitle: "Promoted",
    promotedSub: "30 days · maximum visibility",
    promotedPrice: "£14.99",
    promotedF1: "Everything in Standard",
    promotedF2: "Up to 30 photos",
    promotedF3: "Priority position + \"Promoted\" badge",
    choosePromoted: "Choose Promoted",
    activeTitle: "Active until sold",
    activeSub: "auto-renewing monthly · cancel anytime",
    activePrice: "£19.99",
    activeF1: "Listing stays active as long as the car is for sale",
    activeF2: "Permanent maximum visibility",
    activeF3: "Auto-cancels when you mark it \"Sold\"",
    chooseActive: "Choose Active",
    aiIncluded: "AI listing creation from video",
    recommended: "Recommended",
    bestValue: "Best value",
    free: "Free",
    perMonth: "/mo",
    footer: "Payment is taken after you complete the listing — card, Google Pay or Apple Pay.",
    aiCardTitle: "New: create your listing from a video with AI",
    aiCardBody: "1. Choose Standard, Promoted or Active until sold.\n2. Upload a 60–90 second video of your car.\n3. AI automatically extracts photos and details.\n4. Review and fill in any missing fields in a pre-filled form.\n5. Pay and publish.\n\nAI never publishes on its own — you confirm everything.",
  },
  de: {
    seoTitle: "Verkaufe dein Auto schnell, ohne Provision | RO Auto Market",
    seoDesc: "Inseriere in wenigen Minuten. 3 Pakete: Standard 9,99 €, Beworben 14,99 € oder Aktiv bis verkauft 19,99 €/Monat.",
    heading: "Verkaufe dein Auto schnell, ohne Provision",
    b1: "30 Tage aktiv oder bis verkauft",
    b2: "Sichtbar für tausende Käufer",
    b3: "Sichere Zahlung via Stripe",
    standardTitle: "Standard",
    standardSub: "30 Tage · normale Sichtbarkeit",
    standardPrice: "9,99 €",
    standardF1: "Anzeige 30 Tage veröffentlicht",
    standardF2: "Bis zu 20 Fotos",
    standardF3: "Leichte Priorität in den Ergebnissen",
    chooseStandard: "Standard wählen",
    promotedTitle: "Beworben",
    promotedSub: "30 Tage · maximale Sichtbarkeit",
    promotedPrice: "14,99 €",
    promotedF1: "Alles aus Standard",
    promotedF2: "Bis zu 30 Fotos",
    promotedF3: "Top-Platzierung + „Beworben\"-Badge",
    choosePromoted: "Beworben wählen",
    activeTitle: "Aktiv bis verkauft",
    activeSub: "monatliche Verlängerung · jederzeit kündbar",
    activePrice: "19,99 €",
    activeF1: "Anzeige bleibt aktiv, solange das Auto zum Verkauf steht",
    activeF2: "Dauerhaft maximale Sichtbarkeit",
    activeF3: "Wird automatisch beendet, wenn du „Verkauft\" markierst",
    chooseActive: "Aktiv wählen",
    aiIncluded: "Inserat-Erstellung aus Video mit KI",
    recommended: "Empfohlen",
    bestValue: "Bestes Angebot",
    free: "Kostenlos",
    perMonth: "/Monat",
    footer: "Bezahlung erfolgt nach Fertigstellung der Anzeige — Karte, Google Pay oder Apple Pay.",
    aiCardTitle: "Neu: Erstelle dein Inserat aus einem Video mit KI",
    aiCardBody: "1. Wähle Standard, Beworben oder Aktiv bis verkauft.\n2. Lade ein 60–90 Sekunden Video deines Autos hoch.\n3. Die KI extrahiert automatisch Fotos und Daten.\n4. Prüfe und ergänze fehlende Felder in einem vorausgefüllten Formular.\n5. Bezahle und veröffentliche.\n\nDie KI veröffentlicht nie allein — du bestätigst alles.",
  },
};
